import { createTypes, createAction } from "lib/action";

const LOAD_PLANT = createTypes("plant", "load");
const SHOW_PLANT = createTypes("plant", "show");
const CREATE_PLANT = createTypes("plant", "create");
const UPDATE_PLANT = createTypes("plant", "update");
const DELETE_PLANT = createTypes("plant", "delete");
const IMPORT_PLANT = createTypes("plant", "import");
const EXPORT_PLANT = createTypes("plant", "export");


const loadPlant = {
  request: (params, token) => createAction(LOAD_PLANT.REQUEST, { params, token }),
  success: data => createAction(LOAD_PLANT.SUCCESS, { data }),
  failure: err => createAction(LOAD_PLANT.FAILURE, { err }),
};

const showPlant = {
  request: (id, token) => createAction(SHOW_PLANT.REQUEST, { id, token }),
  success: data => createAction(SHOW_PLANT.SUCCESS, { data }),
  failure: err => createAction(SHOW_PLANT.FAILURE, { err }),
};

const createPlant = {
  request: (params, token) => createAction(CREATE_PLANT.REQUEST, { params, token }),
  success: data => createAction(CREATE_PLANT.SUCCESS, { data }),
  failure: err => createAction(CREATE_PLANT.FAILURE, { err }),
};

const updatePlant = {
  request: (params, id, token) => createAction(UPDATE_PLANT.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_PLANT.SUCCESS, { data }),
  failure: err => createAction(UPDATE_PLANT.FAILURE, { err }),
};

const deletePlant = {
  request: (id, token) => createAction(DELETE_PLANT.REQUEST, { id, token }),
  success: id => createAction(DELETE_PLANT.SUCCESS, { id }),
  failure: err => createAction(DELETE_PLANT.FAILURE, { err }),
};

const importPlant = {
  request: (file, company_id, token, mode) => createAction(IMPORT_PLANT.REQUEST, { file, company_id, token, mode }),
  success: data => createAction(IMPORT_PLANT.SUCCESS, { data }),
  failure: err => createAction(IMPORT_PLANT.FAILURE, { err }),
}

const exportPlant = {
  request: (params, token) => createAction(EXPORT_PLANT.REQUEST, { params, token }),
  success: data => createAction(EXPORT_PLANT.SUCCESS, { data }),
  failure: err => createAction(EXPORT_PLANT.FAILURE, { err }),
}

export {
  loadPlant,
  showPlant,
  createPlant,
  updatePlant,
  deletePlant,
  importPlant,
  exportPlant,
  LOAD_PLANT,
  SHOW_PLANT,
  CREATE_PLANT,
  UPDATE_PLANT,
  DELETE_PLANT,
  IMPORT_PLANT,
  EXPORT_PLANT
};
